import CorporateAccountLayout from 'layouts/CorporateAccountLayout';

import { 
            Container, 
            Row,
            Col,
    } from "reactstrap";


function CorporateMyHome() {
  var user;
  if (localStorage.getItem("user")) {
  user = JSON.parse(localStorage.getItem("user"));
   } else {
   user = { role: "none" };
   };
  


  
  return (
    <>
        {(user.role === "Corporate") && (
            <>
                <CorporateAccountLayout />
                <Container className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                <h2>C'est mon compte pro</h2>
                </Container>
            </>
        )
        }
    </>
  );
}

export default CorporateMyHome;
